import React from 'react'
import Button from 'components/button'
import { Cross } from 'components/icons'
import { closeCustomViewPanel } from './panel'

/** The Edit HTML and Versions panels' header: the panel's name and its close button. */
export default function PanelHeader({ title }: { title: string }) {
  return (
    <div className="flex items-center justify-between gap-2 h-12 px-4 border-b border-divider shrink-0">
      <h2 className="text-sm font-semibold text-body">{title}</h2>
      <Button
        internalType="transparent"
        aria-label="Close panel"
        onClick={closeCustomViewPanel}
        className="w-7 h-7 p-0 text-muted hover:text-body"
      >
        <Cross />
      </Button>
    </div>
  )
}
